export interface NpcByBrand {
  profitCenters: any[];
  markets: any[];
  locationIds: string[];
  locations: any[];
  byMonth: any[];
  total: any;
}

export interface NpcByBrandPayload {
  brandId: string;
  markets: string[];
  locations: number[];
}

interface GetAllNsBrandsAction {
  type: NpcByBrandActionTypes.GET_ALL_NS_BRANDS;
  payload: any[];
}

interface GetNpcByBrandAction {
  type: NpcByBrandActionTypes.GET_NPC_BY_BRAND;
  payload: NpcByBrand;
}

interface SetNpcByBrandLoadingAction {
  type: NpcByBrandActionTypes.SET_NPC_BY_BRAND_LOADING;
}

interface ClearNpcByBrandgAction {
  type: NpcByBrandActionTypes.CLEAR_NPC_BY_BRAND;
}

export enum NpcByBrandActionTypes {
  GET_ALL_NS_BRANDS = 'GET_ALL_NS_BRANDS',
  GET_NPC_BY_BRAND = 'GET_NPC_BY_BRAND',
  SET_NPC_BY_BRAND_LOADING = 'SET_NPC_BY_BRAND_LOADING',
  CLEAR_NPC_BY_BRAND = 'CLEAR_NPC_BY_BRAND',
}

export interface NpcByBrandState {
  brands: any[];
  byBrand: NpcByBrand;
  byBrandConst: {
    markets: any[];
    locations: any[];
    getData: boolean;
  };
  loading: boolean;
  brandsLoading: boolean;
}

export type NpcByBrandAction =
  | SetNpcByBrandLoadingAction
  | GetAllNsBrandsAction
  | GetNpcByBrandAction
  | ClearNpcByBrandgAction;
